module.exports = __webpack_public_path__ + "media/images/rtsLogo-b8c7617a96e6687e312c7fd8af8dfc1e.png";